<template>
  <table class="table is-striped is-fullwidth">
    <tbody>
      <tr>
        <td>{{ $t("form.email") }}:</td>
        <td>
          <a :href="`mailto:${active.email}`">{{ active.email }}</a>
        </td>
      </tr>
      <tr>
        <td>{{ $t("form.phone_number") }}:</td>
        <td>
          <a :href="`tel:${active.country.dial_code + active.phone_number}`">
            {{
            active.country.dial_code + active.phone_number
            }}
          </a>
        </td>
      </tr>
      <tr>
        <td>{{ $t("form.address") }}:</td>
        <td>{{ active.street_name }} {{active.street_number}}</td>
      </tr>
      <tr>
        <td>{{ $t("form.city") }}:</td>
        <td>{{ active.city }}</td>
      </tr>
      <tr>
        <td>{{ $t("form.zipcode") }}:</td>
        <td>{{ active.zipcode }}</td>
      </tr>
      <tr>
        <td>{{ $t("form.state") }}:</td>
        <td>{{ active.state.name }}</td>
      </tr>
      <tr>
        <td>{{ $t("form.country") }}:</td>
        <td>{{ active.country.name }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  computed: {
    active() {
      return this.$store.state.users.active;
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/users/_id/contact.vue